import React from "react";
import { Dropdown } from "react-bootstrap";
import DropdownToggle from "components/dropdown-toggle/DropdownToggle";
import { ReactComponent as OutlineChevronDown12 } from "assets/svg/invoicing/outline-chevron-down-12.svg";
import formatSessionStatus from "components/invoicing/utils/formatSessionStatus";
import styles from "./styles.module.scss";
import getClasses from "utils/getClasses";

const StatusDropdown = ({ type, itemStatus, onItemStatusChange }) => {
  return (
    <DropdownToggle
      title={formatSessionStatus(itemStatus) || "Complete"}
      className={getClasses(
        itemStatus === "complete"
          ? styles["status-dropdown--complete"]
          : styles["status-dropdown--cancel"],
        styles["status-dropdown"],
      )}
      titleClassName={styles["status-dropdown__title"]}
      hideCaret={type === "view"}
      disabled={type === "view"}
      Caret={<OutlineChevronDown12 />}
    >
      <Dropdown.Item onClick={() => onItemStatusChange("complete")}>
        Complete
      </Dropdown.Item>
      <Dropdown.Item onClick={() => onItemStatusChange("no_show")}>
        No Show
      </Dropdown.Item>
      <Dropdown.Item onClick={() => onItemStatusChange("cancel")}>
        Cancel
      </Dropdown.Item>
      <Dropdown.Item onClick={() => onItemStatusChange("late_cancel")}>
        Late Cancel
      </Dropdown.Item>
    </DropdownToggle>
  );
};

export default StatusDropdown;
